"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KEY_DELIMITER = void 0;
/**
 * This is 9999 IQ move
 */
exports.KEY_DELIMITER = "🔥";
